import SC from "./style";
import { useEffect, useState, useRef, useCallback } from "react";
import theme from "@theme";
import BulkActionView from "InnoUI/components/BulkActionView";
import { InputField } from "components";
import {
  CircularProgress,
  FormControlLabel,
  Radio,
  RadioGroup,
} from "@mui/material";
import { submitOption } from "utils/optionData/utils";
import {
  bufferToFile,
  extractAndFindPdfs,
  fetchUrlToFile,
  isAllowedForSummary,
  isZipFile,
  isZipPdfAllowedForSummary,
  MAX_FILE_SIZE,
  regexHelpMap,
  regexPattern,
  regexTypes,
  stripKnownExtension,
  SUMMARY_MAX_SIZE,
} from "utils/config";
import { Button, Label, Tooltip } from "InnoUI/components";
import { apiPost } from "api/callApi";
import axios from "axios";
import {
  AIServices,
  byteToMB,
  extractZipFiles,
  getFileType,
  readFromLocalStorage,
  saveToLocalStorage,
  saveToSessionStorage,
  showAlert,
} from "utils/helper";
import { useNavigate } from "react-router";
import { useSearchParams } from "react-router-dom";
import TooltipText from "components/TooltipText";
import { useSelector } from "react-redux";
import InnoIcons from "@InnoIcons/";
import ProgressBar from "components/ProgressBar";
import { Checkbox } from "antd";
import ReactQuill from "react-quill";

import QuillToolbar, {
  modules,
  formats,
} from "views/ProjectHome/Journal/AddEditJournal/MessageContent/QuillToolbar";
import SummaryPanel from "./SummaryPanel";
import LeftCollapsedButton from "./LeftCollapsedButton";
import { ShimmerSkeleton } from "./SummaryPanel/ShimmerSkeleton";
import { GeneratingText } from "components/GeneratingText";

const actionType = {
  add: "add",
  update: "update",
  edit: "edit",
};

const AddUpdateRevision = (props) => {
  const {
    isEditing,
    setIsEditing,
    isUpdate,
    setOpenModalView,
    openModalView,
    folderData,
    setModalRowData,
    parentId,
    projectId,
    folderId,
    reloadData,
    getHistory,
    isAdding = false,
  } = props;
  // State Management
  const [loading, setLoading] = useState(false);
  const [data, setData] = useState({
    parentId: parentId || null,
    subject: isEditing || isUpdate ? folderData?.subject || "" : "",
    sortOrder: isEditing || isUpdate ? folderData?.sortOrder || 20 : 20,
    projectId: projectId,
    folderId: folderId,
    description: folderData?.description || "",
    note: isEditing ? folderData?.note || "" : "",
    submitOption: 2,
  });

  const [isbulk, setIsbulk] = useState(false);
  const [files, setFiles] = useState([]);
  const [filePreviews, setFilePreviews] = useState([]);
  const fileInputRef = useRef(null);
  const [progress, setProgess] = useState(0);
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const type = searchParams.get("type");
  const projectIds = searchParams.get("projectId");
  const quillRef = useRef(null);

  console.log(folderData, "folderData");

  // AddUpdateRevision component (states)
  const [showSummaryPanel, setShowSummaryPanel] = useState(false);
  const [summaryCollapsed, setSummaryCollapsed] = useState(false);
  const [summaryLoading, setSummaryLoading] = useState(false);
  const [summaryText, setSummaryText] = useState("");
  const [summaryFileName, setSummaryFileName] = useState("");

  // inside AddUpdateRevision component
  const [zipInnerPdf, setZipInnerPdf] = useState(null);
  const [zipPdfCount, setZipPdfCount] = useState(0);
  const [zipSummaryError, setZipSummaryError] = useState("");
  const [showTyping, setShowTyping] = useState(false);
  const [getLoader, setGetLoader] = useState(false);
  const [allData, setAllData] = useState([]);
  const [uploadCompleted, setUploadCompleted] = useState(false);
  const [isUploading, setIsUploading] = useState(false);
  const [uploadProgress, setUploadProgress] = useState(0);

  const uploadAbortRef = useRef(null);

  const handleChange = (property, value) => {
    // 🧠 If sortOrder -> validate with regex
    if (property === "sortOrder") {
      const regex = new RegExp(regexPattern.decimaltwo);
      if (value === "" || regex.test(value)) {
        setData((prevData) => ({ ...prevData, [property]: value }));
      }
      return; // exit here so others don't run
    }

    if (property == "submitOption" && value == 0) {
      setIsbulk(false);
    }
    setData((prevData) => ({ ...prevData, [property]: value }));
  };

  const currentOccupant = useSelector(
    (state) => state?.currentOccupant?.data || [],
  );
  const currentProject = useSelector(
    (state) => state?.currentProject?.data || [],
  );

  const deleteExistingUploadedFile = async () => {
    if (!allData?.length) return;

    try {
      await apiPost("/v1/aws/file/deletefile", {
        fileKey: allData[0].fileUrl,
      });
      setShowSummaryPanel(false);
    } catch (err) {
      console.warn("Old file cleanup failed", err);
    }
  };

  const handleFileChange = async (e) => {
    const file = e.target.files?.[0];
    if (!file) return;

    // 🔥 DELETE OLD FILE WHEN REPLACING
    await deleteExistingUploadedFile();

    setProgess(0);
    setUploadCompleted(false);
    // size validation
    if (file.size > MAX_FILE_SIZE && data.submitOption == 0) {
      showAlert({
        title: "Warning",
        text: `File size exceeds ${byteToMB(MAX_FILE_SIZE)} MB: ${file.name}`,
        icon: "warning",
      });

      // ✅ reset input only on failure
      if (fileInputRef.current) {
        fileInputRef.current.value = "";
      }
      return;
    }

    const uploadedFileKeys = [];
    try {
      const isZip =
        file?.type === "application/zip" ||
        file?.name?.toLowerCase().endsWith(".zip");

      let allFiles = [];
      const uploadedFiles = [];

      if (isbulk && !isZip && !isEditing) {
        showAlert({
          title: "Warning",
          text: `Only Zip files allowed`,
          icon: "warning",
        });
        return;
      }

      setFiles([file]);
      setFilePreviews([URL.createObjectURL(file)]);

      if (!isEditing && file instanceof File) {
        if (isZip && isbulk) {
          const extractedFiles = await extractZipFiles(file);

          // ✅ Ignore macOS junk + hidden files
          const cleanedFiles = extractedFiles.filter((f) =>
            isValidFile(f.fileName),
          );

          allFiles = cleanedFiles.map((f) => {
            // ✅ Remove extension ONLY in bulk upload
            const baseName = getBaseName(f.fileName);
            const nameWithoutExt = baseName.replace(/\.[^/.]+$/, "");
            // Build subject for each file
            const subjectBase =
              type == 1
                ? `${currentOccupant.occupantNo} - ${currentOccupant.occupantName} - ${nameWithoutExt}`
                : `${currentProject.propertyName}- ${nameWithoutExt}`;

            return {
              fileName: baseName,
              fileType: f.fileType || getFileType(f),
              fileSize: f.fileSize,
              content: f.buffer,
              __subjectBase: subjectBase,
            };
          });
        } else {
          allFiles = [
            {
              fileName: file.name,
              fileType: file.type || getFileType(file),
              fileSize: file.size,
              content: file,
              __subjectBase: null,
            },
          ];
        }

        // Compute total upload size
        const totalSize = allFiles.reduce((sum, f) => sum + f.fileSize, 0);
        console.log(totalSize, "totalSize");

        let uploadedBytes = 0;

        let tempData = { ...data };
        delete tempData.files;
        delete tempData.submitOption;

        // 🔥 create new abort controller for this upload
        uploadAbortRef.current = new AbortController();
        setUploadProgress(true);
        for (const f of allFiles) {
          const presignedRes = await apiPost("/v1/file/fileuploadurl", {
            fileName: f.fileName,
            fileType: f.fileType,
          });

          const uploadUrl = presignedRes?.uploadUrl;
          const fileKey = presignedRes?.filekey;

          const uploadedFilesUrl = await getAWSUrl(fileKey);

          console.log(uploadedFilesUrl, fileKey, "uploadedFilesUrl");

          await axios.put(uploadUrl, f.content, {
            headers: {
              "Content-Type": f.fileType,
            },
            signal: uploadAbortRef.current.signal,
            onUploadProgress: (e) => {
              uploadedBytes += e.loaded;
              const percentCompleted = Math.min(
                100,
                Math.round((uploadedBytes / totalSize) * 100),
              );

              setProgess(percentCompleted);
            },
          });
          // Track uploaded key for rollback
          uploadedFileKeys.push(fileKey);

          uploadedFiles.push({
            ...tempData,
            fileName: f.fileName,
            fileType: f.fileType,
            fileSize: f.fileSize,
            fileUrl: fileKey,
            uploadUrl: uploadedFilesUrl,
            // keep helper only
            __subjectBase: f.__subjectBase,
            // subject: f.subject,
          });
        }
      }

      setProgess(100);
      setUploadCompleted(false);
      setAllData(uploadedFiles);
      setUploadCompleted(true);
      setUploadProgress(false);
    } catch (error) {
      if (error.name === "CanceledError" || error.name === "AbortError") {
        console.log("Upload aborted");
        return;
      }

      console.error("Error making API call:", error);
      showAlert({
        title: "Error",
        text: error?.response?.data?.message || "An error occurred",
        icon: "error",
      });
      setProgess(0);
      setUploadCompleted(false);
    } finally {
      setProgess(0);
      setUploadCompleted(false);
      setUploadProgress(false);
    }

    setUploadCompleted(true);

    // reset zip state
    setZipInnerPdf(null);
    setZipPdfCount(0);
    setZipSummaryError("");

    // ZIP handling
    if (isZipFile(file)) {
      (async () => {
        const { pdfs, error } = await extractAndFindPdfs(file, isValidFile);
        setZipPdfCount(pdfs.length);

        if (error) {
          setZipSummaryError("Failed to extract ZIP for summary.");
          return;
        }

        if (pdfs.length === 1) {
          const pdf = pdfs[0];
          console.log(pdf, "wewe");

          setZipInnerPdf({
            fileName: pdf.fileName,
            fileType: pdf.fileType || "application/pdf",
            fileSize: pdf.fileSize,
            buffer: pdf.buffer,
          });
          setZipSummaryError("");
        } else if (pdfs.length === 0) {
          setZipInnerPdf(null);
          setZipSummaryError("No PDF found inside the ZIP.");
        } else {
          setZipInnerPdf(null);
          setZipSummaryError(
            "Multiple PDFs found inside the ZIP. Only one is allowed.",
          );
        }
      })();
    }
  };

  const handleRemoveFile = async (index = 0) => {
    const file = allData?.[index];

    try {
      setIsUploading(true);

      // ✅ CANCEL ongoing upload if exists
      if (uploadAbortRef.current) {
        uploadAbortRef.current.abort();
        uploadAbortRef.current = null;
      }

      // ✅ delete from AWS only if upload completed
      if (file?.fileUrl && uploadCompleted) {
        await apiPost("/v1/aws/file/deletefile", {
          fileKey: file.fileUrl,
        });
      }
      setShowSummaryPanel(false);
    } catch (e) {
      if (e.name === "CanceledError" || e.name === "AbortError") {
        console.log("Upload cancelled by user");
      } else {
        console.warn("Cleanup failed", e);
      }
    } finally {
      // 🔥 reset all state
      setFiles([]);
      setFilePreviews([]);
      setAllData([]);
      setZipInnerPdf(null);
      setZipPdfCount(0);
      setZipSummaryError("");
      setProgess(0);
      setUploadCompleted(false);
      setIsUploading(false);

      if (fileInputRef.current) {
        fileInputRef.current.value = "";
      }
    }
  };

  const handleDrop = (e) => {
    e.preventDefault();
    const newFiles = Array.from(e.dataTransfer.files);
    if (newFiles.length > 0) {
      handleFileChange({ target: { files: [newFiles[0]] } });
    }
  };

  const {
    REACT_APP_BASE_URL: baseURL,
    REACT_APP_REQUEST_TIMEOUT: timeout,
    REACT_APP_API_KEY,
  } = process.env;

  let accessToken = REACT_APP_API_KEY;
  let userAuth = readFromLocalStorage("userAccessToken");
  let BASE_URL = baseURL || `${window.location.origin}/api`;
  userAuth = userAuth === null ? "" : userAuth;

  const getUrl = async (awspath) => {
    try {
      const response = await apiPost(`/v1/file/downloadfile`, {
        filekey: awspath,
        onlyUrl: 1,
      });
      return response.fileUrl;
    } catch (error) {
      console.log("Error: " + error);
      return;
    }
  };
  const getAWSUrl = async (awspath) => {
    try {
      const response = await apiPost(`/v1/file/downloadawsfileurl`, {
        filekey: awspath,
      });
      return response.fileUrl;
    } catch (error) {
      console.log("Error: " + error);
      return;
    }
  };

  const getApiEndPoint = (action, version) => {
    switch (action) {
      case actionType.update:
        return `/v1/file/updatefile${version ? version : ""}`;

      case actionType.edit:
        return `/v1/file/editfile/${folderData.id}`;

      case actionType.add:
      default:
        return `/v1/file/addfile${version ? version : ""}`;
    }
  };

  const getBaseName = (name = "") => {
    const parts = name.split(/[\\/]/);
    return parts[parts.length - 1] || "";
  };

  const isValidFile = (name = "") => {
    const base = getBaseName(name);

    if (!base) return false;
    if (base === "__MACOSX") return false;
    if (base.startsWith("__MACOSX")) return false;
    if (base.startsWith("._")) return false; // macOS resource fork
    if (base.startsWith(".")) return false; // hidden file

    return true;
  };

  const handleAWSUpload = async (e) => {
    e.preventDefault();

    if (!files.length && !isEditing) {
      showAlert({
        title: "Error",
        text: "Please select a file to upload",
        icon: "error",
      });
      return;
    }

    const file = files[0];
    if (file?.size > MAX_FILE_SIZE && data.submitOption == 0) {
      showAlert({
        title: "Warning",
        text: `File size exceeds ${byteToMB(MAX_FILE_SIZE)} MB: ${file.name}`,
        icon: "warning",
      }); // Clear input value
      return;
    }

    setLoading(true);

    // if (isAdding && type == 1) {
    //   const prefix = `${currentOccupant.occupantNo} - ${currentOccupant.occupantName} - `;
    //   data.subject = prefix + data.subject;
    // }

    const uploadedFileKeys = [];

    try {
      const file = files[0];
      const isZip =
        file?.type === "application/zip" ||
        file?.name?.toLowerCase().endsWith(".zip");

      const uploadedFiles = [];

      if (isbulk && !isZip && !isEditing) {
        showAlert({
          title: "Warning",
          text: `Only Zip files allowed`,
          icon: "warning",
        });
        return;
      }

      const prefix =
        type == 1
          ? `${currentOccupant.occupantNo} - ${currentOccupant.occupantName} - `
          : `${currentProject.propertyName}- `;

      // ✅ APPLY SUBJECT HERE (LATEST VALUE)
      const filesWithSubject = allData.map(
        ({ __subjectBase, uploadUrl, ...file }) => ({
          ...file,
          subject: isbulk
            ? __subjectBase
            : isUpdate
              ? data.subject
              : prefix + data.subject,
          note: data?.note,
          sortOrder: data?.sortOrder,
          referenceId: data?.referenceId || null,
          fileDate: data?.fileDate || null,
          fileIntent: data?.fileIntent || null,
          totalPages: data?.totalPages || null,
          isBulkUpload: isbulk === true,
        }),
      );

      const action = isUpdate
        ? actionType.update
        : isEditing
          ? actionType.edit
          : actionType.add;

      console.log(data, "filesWithSubject");

      // return;

      const endpoint = getApiEndPoint(action, "v2");
      const payloadToSend = isEditing ? data : { files: filesWithSubject };

      const response = await apiPost(endpoint, payloadToSend);

      if (isEditing) {
        await Promise.all([getHistory(), reloadData()]);
      }
      setLoading(false);

      // if (data.submitOption === "1") {
      //   saveToSessionStorage(
      //     "submitSend",
      //     `/journal/add-journal?projectId=${projectIds}&type=${type}&folderId=${folderId}`
      //   );
      //   window.location.reload();
      // } else {
      //   showAlert({
      //     title: "Success",
      //     text: response?.data?.message || response?.message,
      //     icon: "success",
      //   });
      //   // window.location.reload();
      // }

      if (data.submitOption == "0") {
        const url = await getUrl(filesWithSubject[0]?.fileUrl);
        const fileDetails = {
          fileName: filesWithSubject[0]?.fileName,
          fileType: filesWithSubject[0]?.fileType,
          fileSize: filesWithSubject[0]?.fileSize,
          fileUrl: url,
          hideFile: true,
          fileId: response.fileId,
        };
        saveToLocalStorage("attachData", fileDetails);
        setLoading(false);

        saveToSessionStorage(
          "submitSend",
          `/journal/add-journal?projectId=${projectIds}&type=${type}&folderId=${folderId}`,
        );
        window.location.reload();
        /* navigate(
                  `/journal/add-journal?projectId=${projectIds}&type=${type}&folderId=${folderId}`
                ); */
      } else if (data.submitOption == "1") {
        saveToSessionStorage(
          "submitSend",
          `/journal/add-journal?projectId=${projectIds}&type=${type}&folderId=${folderId}`,
        );
        window.location.reload();
      } else {
        showAlert({
          title: "Success",
          text: response?.data?.message || response?.message,
          icon: "success",
        });

        if (isUpdate) {
          window.location.href = `/document/file-details?projectId=${projectId}&fileId=${response.fileId[0]}&parentId=${parentId}&folderId=${folderId}&type=${type}`;
        } else {
          window.location.reload();
        }
      }

      setOpenModalView(false);
    } catch (error) {
      if (error.name === "CanceledError") {
        for (const key of uploadedFileKeys) {
          try {
            await apiPost("/v1/file/deletefile", { fileKey: key });
          } catch (delErr) {
            console.warn(`Failed to delete file ${key}`, delErr);
          }
        }

        showAlert({
          title: "Cancelled",
          text: "The request was cancelled.",
          icon: "info",
        });
        return;
      }

      console.error("Error making API call:", error);
      showAlert({
        title: "Error",
        text: error?.response?.data?.message || "An error occurred",
        icon: "error",
      });
    } finally {
      setLoading(false);
    }
  };

  const handleCancelModal = async () => {
    const file = allData?.[0];

    try {
      if (uploadAbortRef.current) {
        uploadAbortRef.current.abort();
        uploadAbortRef.current = null;
      }

      if (file?.fileUrl && uploadCompleted) {
        await apiPost("/v1/aws/file/deletefile", {
          fileKey: file.fileUrl,
        });
      }
    } catch (error) {
      if (error?.name === "CanceledError" || error?.name === "AbortError") {
        console.log("Upload cancelled via modal");
      } else {
        console.warn("Modal cleanup failed", error);
      }
    } finally {
      // 🔄 Reset all state
      setOpenModalView(false);
      setData({});
      setModalRowData(null);
      setFiles([]);
      setFilePreviews([]);
      setAllData([]);
      setZipInnerPdf(null);
      setZipPdfCount(0);
      setZipSummaryError("");
      setProgess(0);
      setUploadCompleted(false);
      setIsUploading(false);

      // allow re-selecting same file
      if (fileInputRef.current) {
        fileInputRef.current.value = "";
      }
    }
  };

  const handleCancelModalisEditing = () => {
    if (loading) {
      alert("Please wait upload is in progress");
      return;
    }
    setOpenModalView(false);
    setIsEditing(false);
    setData({});
    setModalRowData(null);
  };

  const handleFileDialogClick = () => {
    fileInputRef.current.click();
  };

  const getCaption = (loading) => {
    if (loading) {
      return "Submitting...";
    } else {
      return "Submit";
    }
  };

  const handleChangeTextEditor = useCallback(
    (content) => {
      setData((prevData) => ({
        ...prevData,
        note: content,
      }));
    },
    [setData],
  );

  useEffect(() => {
    if (!files.length) {
      setZipInnerPdf(null);
      setZipPdfCount(0);
      setZipSummaryError("");
      return;
    }
    const f = files[0];
    if (isZipFile(f)) {
      // reuse the same extraction routine
      (async () => {
        const { pdfs, error } = await extractAndFindPdfs(f, isValidFile);
        setZipPdfCount(pdfs.length);
        if (error) {
          setZipSummaryError("Failed to extract ZIP for summary.");
          return;
        }
        if (pdfs.length === 1) {
          const pdf = pdfs[0];
          setZipInnerPdf({
            fileName: pdf.fileName,
            fileType: pdf.fileType || "application/pdf",
            fileSize: pdf.fileSize,
            buffer: pdf.buffer,
          });
          setZipSummaryError("");
        } else if (pdfs.length === 0) {
          setZipInnerPdf(null);
          setZipSummaryError("No PDF found inside the ZIP.");
        } else {
          setZipInnerPdf(null);
          setZipSummaryError(
            "Multiple PDFs found inside the ZIP. Only one is allowed.",
          );
        }
      })();
    } else {
      setZipInnerPdf(null);
      setZipPdfCount(0);
      setZipSummaryError("");
    }
  }, [files]);

  // Call API to generate summary (example uses apiPost; adapt endpoint/payload)
  const handleGenerateSummary = async () => {
    console.log("allData", allData[0]);

    if (uploadProgress) {
      alert("Please wait upload is in progress");
      return;
    }

    // return;
    let uploadFile = null;
    if (zipInnerPdf && zipPdfCount === 1) {
      // convert buffer -> File
      uploadFile = bufferToFile(
        zipInnerPdf.buffer,
        zipInnerPdf.fileName,
        zipInnerPdf.fileType,
      );
    } else if (files.length > 0) {
      uploadFile = allData[0]?.uploadUrl;
    }

    if (!uploadFile) {
      showAlert({
        title: "Error",
        text: "No file available to summarize",
        icon: "error",
      });
      return;
    }

    setSummaryLoading(true);
    setShowSummaryPanel(true);
    setSummaryCollapsed(false);
    setSummaryText("");

    try {
      const fd = new FormData();
      fd.append(
        zipInnerPdf && zipPdfCount === 1 ? "file" : "fileUrl",
        uploadFile,
      );
      fd.append("parentId", parentId);
      fd.append("folderId", folderId);

      // If your summarizer expects other fields, append them (project id, flags, etc.)
      // Replace this URL with the actual summarizer endpoint if different
      const summarizerUrl = `${BASE_URL}/v1/file/getfilesummary`;

      const res = await axios.post(summarizerUrl, fd, {
        headers: {
          "Content-Type": "multipart/form-data",
          api_key: accessToken,
          Authorization: `Bearer ${userAuth}`,
        },
        timeout: timeout ? parseInt(timeout, 10) * 1000 : 180000,
      });

      // // // Adapt to your backend response structure:
      const summary = res?.data?.result?.summary;
      setSummaryText(summary || "");
      setSummaryFileName(res?.data?.result);
    } catch (err) {
      console.error("Summary generation failed:", err);
      showAlert({
        title: "Error",
        text:
          err?.response?.data?.message ||
          err?.message ||
          "Failed to generate summary",
        icon: "error",
      });
    } finally {
      setSummaryLoading(false);
    }
  };

  // helper: strip HTML -> plain text
  // helper: strip HTML -> plain text (keeps whitespace/newlines reasonably)
  const stripHtmlToPlain = (html) => {
    if (!html) return "";
    const tmp = document.createElement("DIV");
    tmp.innerHTML = html;
    // collapse multiple spaces and keep line breaks by replacing <div><br> types
    // but simplest: use textContent which preserves whitespace/newlines in many cases
    return tmp.textContent || tmp.innerText || "";
  };

  const handleUseAsSubmissionNote = () => {
    const html = summaryText || ""; // summaryText comes from SummaryPanel's ReactQuill
    const plain = stripHtmlToPlain(html);

    setData((prev) => {
      let subject = prev.subject;

      if (isEditing || isUpdate) {
        // Edit / Update mode → use folder subject
        subject = folderData?.subject || subject;
      } else if (!subject?.trim()) {
        // Create mode → set from filename ONLY if subject is empty
        subject = stripKnownExtension(summaryFileName?.fileName || "");
      }
      return {
        ...prev,
        note: plain,
        subject,
        referenceId: summaryFileName?.referenceId || null,
        fileDate: summaryFileName?.fileDate || null,
        fileIntent: summaryFileName?.fileIntent || null,
        totalPages: summaryFileName?.totalPages || null,
      };
    });

    // Update the main Quill editor to show the rich HTML (keeps bold/italic/etc)
    try {
      const editor = quillRef.current?.getEditor();
      if (editor) {
        // Replace editor contents with HTML
        editor.clipboard.dangerouslyPasteHTML(html);

        // Quill sometimes adds an extra trailing newline; remove it for clean text if desired
        const len = editor.getLength(); // includes trailing newline
        if (len > 1) {
          const lastChar = editor.getText(len - 2, 1); // char before trailing newline
        }
      }
    } catch (e) {
      console.warn("Failed to set quill HTML", e);
      // fallback: put plain text into editor
      try {
        const editor = quillRef.current?.getEditor();
        if (editor) editor.setText(plain);
      } catch {}
    }

    // hide panel
    setShowSummaryPanel(false);
  };

  const handleCollapsedSummaryBack = () => {
    setShowSummaryPanel(true);
    setSummaryCollapsed(!summaryCollapsed);
  };

  useEffect(() => {
    if (isbulk) {
      setShowSummaryPanel(false);
      setSummaryCollapsed(false);
      setZipInnerPdf(null);
      setZipPdfCount(0);
      setZipSummaryError("");
    }
  }, [isbulk]);

  useEffect(() => {
    const loadExistingFile = async () => {
      if (!isEditing || !AIServices()) return;
      if (files.length > 0) return;
      const fileRef = folderData?.fileUrl;
      if (!fileRef) return;
      try {
        setGetLoader(true);
        const resolvedUrl = /^https?:\/\//i.test(fileRef)
          ? fileRef
          : await getAWSUrl(folderData.fileUrl);
        const existingName =
          folderData?.fileName ||
          decodeURIComponent(String(fileRef).split("/").pop());

        console.log(resolvedUrl, "resolvedUrl");

        const f = await fetchUrlToFile(resolvedUrl, existingName);
        if (!f) throw new Error("Failed to fetch existing file");
        setFiles([f]);
        setAllData([
          {
            fileKey: folderData.fileUrl, // AWS key from backend
            uploadUrl: resolvedUrl, // real HTTP URL
            fileName: existingName,
            fileType: f.type,
            fileSize: f.size,
          },
        ]);

        setFilePreviews([URL.createObjectURL(f)]);
        if (isZipFile(f)) {
          const { pdfs } = await extractAndFindPdfs(f, isValidFile);
          setZipPdfCount(pdfs.length);
          if (pdfs.length === 1)
            setZipInnerPdf({
              fileName: pdfs[0].fileName,
              fileType: pdfs[0].fileType,
              fileSize: pdfs[0].fileSize,
              buffer: pdfs[0].buffer,
            });
        }
        setGetLoader(false);
      } catch (err) {
        console.warn("loadExistingFile error", err);
        setFiles([]);
        setFilePreviews([]);
        setZipInnerPdf(null);
        setZipPdfCount(0);
      } finally {
        setGetLoader(false);
      }
    };
    loadExistingFile();
  }, [isEditing, folderData]);

  const summaryPanelProps = {
    summaryText,
    summaryLoading,
    summaryCollapsed,
    setSummaryText,
    showTyping,
    setShowTyping,
    onToggleCollapse: () => {
      setSummaryCollapsed((s) => !s);
      setShowSummaryPanel(false);
    },
    onUseAsNote: handleUseAsSubmissionNote,
    onClose: () => setShowSummaryPanel(false),
  };

  const leftCollapsedButtonProps = {
    onClick: handleCollapsedSummaryBack,
  };

  const displayedProgress =
    progress < 100 ? progress : uploadCompleted ? 100 : 98;

  const AddModalData = () => {
    return (
      <>
        {/* <form onSubmit={handleAWSUpload} style={{ width: "100%" }}> */}
        <form
          onSubmit={handleAWSUpload}
          style={{
            width: "100%",
            display: "flex", // ⭐ Add
            flexDirection: "column", // ⭐ Add
            height: "100%", // ⭐ Add
            overflow: "hidden", // ⭐ Add
          }}
        >
          {/* <div
            style={{
              maxHeight: "600px",
              overflowY: "auto",
              paddingRight: "10px",
            }}
          > */}

          <div
            style={{
              flex: 1, // ⭐ Changed from maxHeight: "600px"
              overflowY: "auto",
              paddingRight: "10px",
              minHeight: 0, // ⭐ Add this
            }}
          >
            {!isEditing && (
              <>
                {/* Submit Option */}
                <div
                  style={{
                    padding: "15px 15px 5px 15px",
                    borderBottom: `1px solid ${theme.colors.themeColor}`,
                  }}
                >
                  <span style={{ fontWeight: "bold", fontSize: "12px" }}>
                    Submit Option
                  </span>
                  <RadioGroup
                    row
                    name="submitOption"
                    value={data?.submitOption}
                    onChange={(e) =>
                      handleChange("submitOption", e.target.value)
                    }
                  >
                    {submitOption.map((option) => (
                      <FormControlLabel
                        key={option.id}
                        value={option.id}
                        control={
                          <Radio
                            sx={{
                              "& .MuiSvgIcon-root": {
                                fontSize: 20,
                              },
                              "&.Mui-checked": {
                                color: "#EC810B",
                              },
                              margin: "0px 0px 0px 10px",
                            }}
                          />
                        }
                        label={option.label}
                      />
                    ))}
                  </RadioGroup>
                </div>
              </>
            )}

            {/* Media Upload */}
            <div
              style={{
                display: "flex",
                flexDirection: "column",
                padding: " 5px 15px 15px 15px",
              }}
            >
              <div
                style={{
                  display: "flex",
                  justifyContent: "flex-end",
                  gap: "10px",
                  flexShrink: 0, // ⭐ Prevent buttons from shrinking
                }}
              >
                <Button
                  caption="Cancel"
                  onClick={
                    isEditing ? handleCancelModalisEditing : handleCancelModal
                  }
                  fontSize="12px"
                  //disabled={loading}
                  disabled={false}
                  style={{
                    background: theme.colors.cancelButton,
                    color: theme.colors.white,
                    minWidth: "90px",
                    borderRadius: "3px",
                    height: "30px",
                    fontSize: "12px",
                  }}
                />
                <Button
                  caption={getCaption(loading, progress)}
                  isLoading={loading}
                  type="submit"
                  color="white"
                  fontSize="12px"
                  style={{
                    background: theme.gradient.themeGradient,
                    color: theme.colors.white,
                    minWidth: "90px",
                    height: "30px",
                    borderRadius: "3px",
                  }}
                  disabled={loading || uploadProgress}
                />
              </div>

              {!isEditing && (
                <>
                  <div
                    style={{
                      display: "flex",
                      alignItems: "center",
                      textAlign: "center",
                      padding: "0px 0px 10px 0px ",
                      justifyContent: "space-between",
                    }}
                  >
                    <span style={{ fontWeight: "bold" }}>Media Upload</span>
                    {/* Replace the existing button markup with this */}

                    {data.submitOption != 0 && (
                      <Checkbox
                        checked={!!isbulk}
                        onChange={(e) => {
                          const checked = e.target.checked;
                          setIsbulk(checked);
                          if (checked) {
                            // close summary panel when bulk mode enabled
                            setShowSummaryPanel(false);
                            setSummaryCollapsed(false);
                          }
                        }}
                        style={{
                          fontWeight: "bold",
                          margin: "4px 0",
                          display: "flex",
                          opacity: "0.8",
                        }}
                      >
                        {"Bulk Upload.zip"}
                      </Checkbox>
                    )}
                  </div>
                </>
              )}

              {getLoader ? (
                <div
                  style={{
                    display: "flex",
                    justifyContent: "center",
                    marginTop: "10px",
                  }}
                >
                  <ShimmerSkeleton lines={1} />
                </div>
              ) : (
                <div
                  style={{
                    display: "flex",
                    gap: 8,
                    padding: "0px 0px 10px 0px",
                  }}
                >
                  {/* If bulk → render nothing */}
                  {isbulk || !AIServices() ? null : (
                    <>
                      {/* SHOW BUTTON WHEN FILE IS ALLOWED OR ZIP HAS EXACTLY 1 PDF */}
                      {
                        // CASE 1: Non-ZIP file allowed normally
                        isAllowedForSummary(files[0]) ||
                        // CASE 2: ZIP contains exactly 1 PDF *and* PDF < 50MB
                        (zipPdfCount === 1 &&
                          isZipPdfAllowedForSummary(zipInnerPdf)) ? (
                          <Button
                            leftIcon={
                              summaryLoading ? (
                                <CircularProgress
                                  size={14}
                                  thickness={5}
                                  sx={{ color: theme.colors.themeColor }}
                                />
                              ) : (
                                <InnoIcons.AutoAwesomeIcon
                                  sx={{ color: theme.colors.themeColor }}
                                />
                              )
                            }
                            caption={
                              summaryLoading ? (
                                <GeneratingText />
                              ) : (
                                "Generate Summary"
                              )
                            }
                            onClick={handleGenerateSummary}
                            fontSize="12px"
                            disabled={summaryLoading}
                            style={{
                              minWidth: "140px",
                              border: "1px solid #FFCA28",
                              borderRadius: "50px",
                              height: "36px",
                              boxShadow:
                                "0 2px 4px rgba(0,0,0,0.1), 0 4px 10px rgba(0,0,0,0.08)",
                              cursor: summaryLoading ? "progress" : "pointer",
                            }}
                          />
                        ) : (
                          <>
                            {files.length === 0 ? (
                              <div
                                style={{
                                  alignSelf: "center",
                                  color: "#777",
                                  fontSize: 12,
                                }}
                              >
                                Upload a PDF (≤ 32 MB) to enable summary
                              </div>
                            ) : zipPdfCount > 1 ? (
                              <div
                                style={{
                                  alignSelf: "center",
                                  color: "#777",
                                  fontSize: 12,
                                }}
                              >
                                ZIP contains multiple PDF files — only one is
                                allowed for summary
                              </div>
                            ) : zipPdfCount === 0 && isZipFile(files[0]) ? (
                              <div
                                style={{
                                  alignSelf: "center",
                                  color: "#777",
                                  fontSize: 12,
                                }}
                              >
                                No PDF found inside the ZIP file
                              </div>
                            ) : zipPdfCount === 1 &&
                              zipInnerPdf?.fileSize >= SUMMARY_MAX_SIZE ? (
                              /* ⭐ NEW MESSAGE FOR ZIP WITH 1 PDF BUT PDF IS TOO LARGE */
                              <div
                                style={{
                                  alignSelf: "center",
                                  color: "#777",
                                  fontSize: 12,
                                }}
                              >
                                The PDF inside the ZIP exceeds the 32 MB limit
                              </div>
                            ) : files[0].size >= SUMMARY_MAX_SIZE &&
                              !zipInnerPdf ? (
                              <div
                                style={{
                                  alignSelf: "center",
                                  color: "#777",
                                  fontSize: 12,
                                }}
                              >
                                File is too large for summary (max 32 MB)
                              </div>
                            ) : !isAllowedForSummary(files[0]) &&
                              zipPdfCount !== 1 ? (
                              <div
                                style={{
                                  alignSelf: "center",
                                  color: "#777",
                                  fontSize: 12,
                                }}
                              >
                                Summary available for PDF only
                              </div>
                            ) : null}
                          </>
                        )
                      }
                    </>
                  )}
                </div>
              )}

              {!isEditing && (
                <>
                  <SC.Container>
                    <SC.DropzoneWrapper
                      onDragOver={(e) => e.preventDefault()}
                      onDrop={handleDrop}
                      onClick={handleFileDialogClick}
                    >
                      <SC.UploadFileContiner>
                        <div
                          style={{
                            display: "flex",
                            flexDirection: "column",
                          }}
                        >
                          <SC.Span>
                            <SC.UploadIcon />
                          </SC.Span>
                          <div>
                            <span style={{ fontSize: "12px" }}>
                              Drop your file or
                            </span>
                            <span
                              style={{
                                color: theme.colors.blue,
                                fontSize: "14px",
                              }}
                            >
                              {" "}
                              browse
                            </span>
                          </div>
                          <span style={{ fontSize: "12px", opacity: "0.8" }}>
                            {data.submitOption == 0
                              ? `Max ${byteToMB(MAX_FILE_SIZE)} MB file is allowed`
                              : ""}
                          </span>
                        </div>
                      </SC.UploadFileContiner>
                    </SC.DropzoneWrapper>
                    <input
                      type="file"
                      name="file"
                      style={{ display: "none" }}
                      onChange={handleFileChange}
                      ref={fileInputRef}
                      tabIndex={-1}
                      aria-hidden="true"
                    />
                  </SC.Container>
                  <span
                    style={{
                      fontSize: "12px",
                      opacity: "0.8",
                      padding: "10px 0px 10px 0px",
                    }}
                  >
                    {/* Only support .jpg, .png and .pdf and zip file */}
                  </span>
                  <SC.PreviewsContainer>
                    {filePreviews.map((preview, index) => {
                      const file = files[index];
                      const fileSize =
                        file?.size > 1048576
                          ? `${(file.size / 1048576).toFixed(2)} MB`
                          : `${(file.size / 1024).toFixed(2)} KB`;

                      return (
                        <SC.PreviewBox key={index}>
                          <div
                            style={{
                              display: "flex",
                              alignItems: "center",
                            }}
                          >
                            <SC.Image
                              src={preview}
                              alt="file preview"
                              width="20px"
                              height="15px"
                            />
                            <SC.FileName>
                              <TooltipText
                                title={file?.name}
                                maxLength={100}
                                style={{ fontSize: "12px" }}
                              />

                              <p
                                style={{
                                  paddingBlock: "0px",
                                  marginBlock: "0px",
                                  fontWeight: "normal",
                                }}
                              >
                                {fileSize}
                              </p>
                            </SC.FileName>
                          </div>
                          {isUploading ? (
                            <small style={{ fontSize: "11px" }}>
                              <GeneratingText label="Removing" />
                            </small>
                          ) : (
                            <SC.CloseIcon
                              onClick={() => handleRemoveFile(index)}
                            />
                          )}
                        </SC.PreviewBox>
                      );
                    })}
                  </SC.PreviewsContainer>
                </>
              )}
            </div>

            <div style={{ padding: "0px 10px" }}>
              {progress > 0 && <ProgressBar progress={displayedProgress} />}
            </div>

            {!isbulk && (
              <>
                <SC.LabelContainer>
                  <SC.Label>
                    File Name <SC.Astrik>*</SC.Astrik>
                  </SC.Label>
                  <SC.Children>
                    <SC.Wrapper>
                      <div
                        style={{
                          width: "100%",
                          padding: "0px",
                          display: "flex",
                          alignItems: "center",
                        }}
                      >
                        {isAdding && (
                          <span
                            title={
                              type == 1
                                ? `${currentOccupant?.occupantNo} - ${currentOccupant?.occupantName}`
                                : `${currentProject?.propertyName}`
                            }
                            style={{
                              width: "190px",
                              cursor: "pointer",
                              overflow: "hidden",
                              whiteSpace: "nowrap",
                              textOverflow: "ellipsis",
                              display: "inline-block", // required for ellipsis to work
                              fontSize: "12px",
                            }}
                          >
                            {type == 1
                              ? `${currentOccupant?.occupantNo} - ${currentOccupant?.occupantName} - `
                              : `${currentProject?.propertyName}- `}
                          </span>
                        )}

                        <InputField
                          name="subject"
                          value={data?.subject || ""}
                          onChange={handleChange}
                          required
                          maxLength={3000}
                          // regexType={regexTypes.forFileName}
                          style={{
                            width: "100%",
                            height: "34px",
                          }}
                        />

                        <Tooltip
                          title={regexHelpMap[regexTypes.forFileName]}
                          backgroundcolor="#333333"
                        >
                          <InnoIcons.InfoIcon
                            style={{
                              color: theme.colors.themeColor,
                              cursor: "pointer",
                              fontSize: "20px",
                            }}
                          />
                        </Tooltip>
                      </div>
                    </SC.Wrapper>
                  </SC.Children>
                </SC.LabelContainer>

                <Label label="Select Order">
                  <InputField
                    name="sortOrder"
                    value={data?.sortOrder || ""}
                    onChange={handleChange}
                    required
                    maxLength={5}
                    type="number"
                    style={{
                      width: "100%",
                      height: "34px",
                    }}
                  />
                </Label>

                <Label label="Document Summary" align="start">
                  <SC.QuillWrapper>
                    <QuillToolbar
                      showUndoRedo={false}
                      showHeader={false}
                      showStrike={false}
                      showColor={false}
                      showBackground={false}
                      showImage={false}
                    />
                    <ReactQuill
                      ref={quillRef}
                      theme="snow"
                      value={data.note || ""}
                      onChange={handleChangeTextEditor}
                      placeholder="Write something awesome..."
                      modules={modules}
                      formats={formats}
                      style={{ height: "100%" }}
                    />
                  </SC.QuillWrapper>
                </Label>
              </>
            )}
          </div>

          {/* Footer Buttons */}
          {/* <div
            style={{
              display: "flex",
              justifyContent: "flex-end",
              gap: "10px",
              margin: "20px 10px 20px 10px",
            }}
          > */}

          <div
            style={{
              display: "flex",
              justifyContent: "flex-end",
              gap: "10px",
              margin: "10px",
              flexShrink: 0, // ⭐ Prevent buttons from shrinking
              borderTop: "1px solid #e0e0e0", // ⭐ Optional: visual separator
              paddingTop: "15px", // ⭐ Optional: spacing
            }}
          >
            <Button
              caption="Cancel"
              onClick={
                isEditing ? handleCancelModalisEditing : handleCancelModal
              }
              fontSize="12px"
              //disabled={loading}
              disabled={false}
              style={{
                marginBottom: 8,
                background: theme.colors.cancelButton,
                color: theme.colors.white,
                minWidth: "90px",
                borderRadius: "3px",
                height: "30px",
                fontSize: "12px",
              }}
            />
            <Button
              caption={getCaption(loading, progress)}
              isLoading={loading}
              type="submit"
              color="white"
              fontSize="12px"
              style={{
                marginBottom: 8,
                background: theme.gradient.themeGradient,
                color: theme.colors.white,
                minWidth: "90px",
                height: "30px",
                borderRadius: "3px",
              }}
              disabled={loading || uploadProgress}
            />
          </div>
        </form>
      </>
    );
  };

  return (
    <>
      {openModalView &&
        (isEditing ? (
          <BulkActionView
            title={`Edit`}
            openModal={openModalView}
            renderBodyConditionally={AddModalData}
            closeIcon={loading}
            handleCloseModal={() => {
              setOpenModalView(false);
              setIsEditing(false);
              setData("");
              setModalRowData(null);
              handleCancelModal();
            }}
            leftPanelWidth={"50%"}
            leftPanelCollapsed={summaryCollapsed}
            showSummaryPanel={showSummaryPanel}
            setShowSummaryPanel={setShowSummaryPanel}
            setSummaryCollapsed={setSummaryCollapsed}
            handleCollapsedSummaryBack={handleCollapsedSummaryBack}
            leftPanelCollapsedButton={
              <LeftCollapsedButton {...leftCollapsedButtonProps} />
            }
            leftPanel={<SummaryPanel {...summaryPanelProps} />}
            horizontalWidth={"650px"}
          />
        ) : (
          <BulkActionView
            title={isUpdate ? "Update" : "New"}
            openModal={openModalView}
            renderBodyConditionally={AddModalData}
            closeIcon={loading}
            handleCloseModal={() => {
              setOpenModalView(false);
              setData("");
              setModalRowData(null);
              handleCancelModal();
            }}
            sx={{
              minWidth: isUpdate ? "100%" : "100%",
            }}
            isAdd={isAdding ? "500px" : "500px"}
            leftPanel={<SummaryPanel {...summaryPanelProps} />}
            leftPanelWidth={"50%"}
            leftPanelCollapsed={summaryCollapsed}
            showSummaryPanel={showSummaryPanel}
            setShowSummaryPanel={setShowSummaryPanel}
            setSummaryCollapsed={setSummaryCollapsed}
            handleCollapsedSummaryBack={handleCollapsedSummaryBack}
            leftPanelCollapsedButton={
              <LeftCollapsedButton {...leftCollapsedButtonProps} />
            }
            horizontalWidth={"650px"}
          />
        ))}
    </>
  );
};

export default AddUpdateRevision;
